import React from 'react';

const Note = ({ id, note, onDeleteNote, activeNote, setActiveNote, setFavoriteNote, setCompleteNote }) => {

    return (
        <div
            className={`note ${note.id === activeNote.id ? 'opened' : ''}`}
            onClick={() => setActiveNote(note)}>
            <span
                className={`icon-button note__completed-toggle  material-icons ${note.completed === true ? ' completed' : ''}`}
                onClick={() => setCompleteNote(note.id)}>check</span>
            <div className="note__title">{note.title}</div>
            <span
                className={`icon-button note__starred-toggle material-icons${note.favorite === true ? ' starred' : ''}`}
                onClick={() => setFavoriteNote(note.id)}>{note.favorite === true ? 'star' : 'star_outline'}</span>
            <span className="icon-button note__delete material-icons" onClick={() => onDeleteNote(note.id)}>delete_outline</span>
        </div>
    );
}

export default Note;